import { render, staticRenderFns } from "./sumgraphquantities.vue?vue&type=template&id=9bb5784e&scoped=true&"
import script from "./sumgraphquantities.vue?vue&type=script&lang=js&"
export * from "./sumgraphquantities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb5784e",
  null
  
)

export default component.exports